// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ServiceLevelObjectivesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ServiceLevelObjectivesIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M12.25 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0" />
      <path d="M12.5 13a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M11 13a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
      <path d="M6.5 1.5h7A2.5 2.5 0 0 1 16 4v12a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 16V4a2.5 2.5 0 0 1 2.5-2.5m7 1.5h-7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1" />
    </SvgIcon>
  );
});

/**
 * Use to show the concept of SLO's, not suitable for intent buttons
 * @public
 */
export const ServiceLevelObjectivesIcon = /* @__PURE__ */ Object.assign(
  ServiceLevelObjectivesIconComponent,
  { displayName: 'ServiceLevelObjectivesIcon' },
);
